import differentiatorImage from '@/assets/about/differentiator.jpg';

export default function DifferentiatorSection() {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="relative">
            <img
              src={differentiatorImage}
              alt="Команда специалистов обсуждает проект"
              className="w-full h-96 object-cover object-top rounded-lg"
            />
          </div>
          
          <div>
            <div className="text-center mb-16">
              <h2 className="text-4xl font-light text-gray-900 mb-4">
                Мы партнеры, а не просто подрядчики
              </h2>
            </div>
            
            <p className="text-lg text-gray-600 mb-12 leading-relaxed font-light">
              Погружаемся в задачи заказчика, работаем рядом с вашей командой и доводим проект до измеримых результатов.
            </p>
            
            <div className="space-y-8">
              <div className="flex items-start space-x-4">
                <div className="w-1 h-1 bg-gray-400 rounded-full mt-3"></div>
                <div>
                  <h4 className="font-medium text-gray-900 mb-2">Совместная реализация</h4>
                  <p className="text-gray-600 font-light">Не ограничиваемся советами — берем ответственность за внедрение решений.</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-4">
                <div className="w-1 h-1 bg-gray-400 rounded-full mt-3"></div>
                <div>
                  <h4 className="font-medium text-gray-900 mb-2">Осязаемые показатели</h4>
                  <p className="text-gray-600 font-light">Фиксируем KPI заранее и регулярно показываем прогресс по каждому направлению.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
